<template>
  <v-card>
    <v-card-title class="report-title">
      <v-layout row wrap align-end>
        <v-flex xs12 md6>
          <h3>{{ `Time Period: ${report.periodStartName} - ${report.periodEndName}` }}</h3>
        </v-flex>
        <v-flex xs12 md6 text-md-right>
          <h2>{{ report.locationName }}</h2>
          <div v-if="report.locationName" class="body-1">{{ report.locationAddress }}</div>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-card
        v-for="(item, key) in report.content"
        :key="key"
        :elevation="key === 0 ? 4 : 1"
      >
        <v-container pa-3 :mb-2="key !== 0" :mb-4="key === 0"
                     v-if="typeof item.topic.show === 'undefined' || item.topic.show">
          <v-layout
            row
            wrap
            :class="[{'topic-header-with-value': item.topic.value !== undefined}, item.topic.type]"
          >
            <v-flex xs10>
              <h3 class="topic-header">{{ item.topic.header }}</h3>
              <span class="hint">{{ item.topic.hint }}</span>
            </v-flex>
            <v-flex xs2>
              <span>{{ item.topic.value }}</span>
            </v-flex>
          </v-layout>

          <v-layout
            row
            wrap
            v-for="(entry,key) in item.entries"
            :class="['report-entry', entry.type]"
            :key="key"
          >
            <template v-if="typeof entry.show === 'undefined' || entry.show">
              <v-flex xs10>
                <span>{{ entry.header }}</span>
                <span class="hint">{{ entry.hint }}</span>
              </v-flex>
              <v-flex xs2>
                <span>{{ entry.value || '-' }}</span>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    components: {
    },

    props: {
      report: Object
    },

    data () {
      return {
      }
    },
  }
</script>

<style lang="stylus" scoped>
  .report-title
    padding-bottom: 0px

  .topic-header
    color: var(--v-primary-base)
    display: inline

  .hint
    margin-left: 10px
    color: grey

  .report-entry:hover, .topic-header-with-value:hover
    background-color: LightGrey

  .report-remarks
    margin-top: 20px

  .subtotal
    font-weight: bold

  .clickable
    cursor: pointer
    text-decoration: underline
    color: var(--v-primary-base)
</style>



// WEBPACK FOOTER //
// src/components/Rental/FranchiseeReports/FranchiseeReport.vue